import api, { apiSetup } from '../api';

apiSetup();

export class EtapasService {
  BASE_URL = '/etapas';

  get() {
    return api.get(this.BASE_URL);
  }
}
